export const getEventsOptions = (isAction, events) =>
  events
    .filter((item) => (isAction ? item.is_action : item.is_trigger))
    .map(({ title, id }) => ({ label: title, value: id }));
